// extracted by mini-css-extract-plugin
export default {"external":"aNmQb8","block":"bNmQb8","section":"cNmQb8"};